<template>
  <div class="program-list">
    <v-card class="m-4" v-if="student">
      <v-card-title>{{$t('studentInformation')}}</v-card-title>
      <v-card-text>
        <p>{{$t('studentName')}}: {{ student.full_name }}</p>
        <p>{{$t('studentList.studentEmail')}}: {{ student.email }}</p>
      </v-card-text>
    </v-card>
    <div class="program-header">
      <h2>{{ $t("reservation.availablePrograms") }}</h2>
      <v-btn
        class="action-btn"
        color="green darken-3"
        @click="studentsDialog = true"
        v-if="isOperator"
        >{{$t('sideMenu.students')}}</v-btn
      >
    </div>
    <ProgramList :programs="programs" />

    <!-- Students Dialog -->
    <v-dialog
      transition="dialog-bottom-transition"
      max-width="1400"
      v-model="studentsDialog"
      persistent
      v-if="isOperator"
    >
      <v-card class="p-4">
        <v-card-title>
          <span class="text-h4">
            {{$t("chooseStudent")}}
          </span>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-2 btn-round"
            small
            color="primary"
            @click="studentsDialog = false"
          >
            <v-icon dark>
              mdi-window-close
            </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="card-content">
          <StudentList @saveStudentId="hideStudentDialog"></StudentList>
        </v-card-text>
        <v-card-actions class="actions-btn-group pe-6">
          <v-btn
            class="action-btn"
            color="red darken-3"
            @click="studentsDialog = false"
            >{{ $t("close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GlobalMixin from "@/GlobalMixin";
import ProgramList from "../../components/NewReservation/ProgramList.vue";
import StudentList from "../../components/NewReservation/StudentsList.vue";
import { mapGetters } from "vuex";

export default {
  name: "ProgramsView",
  mixins: [GlobalMixin],
  components: { ProgramList, StudentList },
  data() {
    return {
      programs: [],
      isOperator:
        JSON.parse(localStorage.getItem("vuex")).auth.user.user.user_type ===
        "operator" || JSON.parse(localStorage.getItem("vuex")).auth.user.user.user_type ===
        "institute_admin",
      studentsDialog: true,
    };
  },
  /**
   * Initialize component
   */
  mounted() {
    // Get all programs
    this.getPrograms();
  },
  methods: {
    /**
     * Get all programs for a specifi tutor
     */
    getPrograms() {
      this.axios(`${process.env.VUE_APP_APIEndPoint}tutor/programs/`).then(
        (res) => (this.programs = res.data)
      );
    },
    hideStudentDialog(event) {
      this.studentsDialog = event;
    },
  },
  computed: {
    ...mapGetters({
      student: 'GET_STUDENT'
    })
  }
};
</script>

<style lang="scss" scoped>
.program-list {
  margin-top: 36px;
  font-family: $font-family;
  font-style: normal;
  h2 {
    font-weight: 600;
    font-size: 1.25rem;
    line-height: 1.4375rem;
    color: $title;
    margin-bottom: 16px;
  }
  .program-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.card-content {
  margin-top: -2rem;
}
.actions-btn-group {
  display: flex;
  justify-content: center;
  gap: 2rem;
}

.action-btn {
  color: #fff;
}
</style>
